import src from "IMAGE";
export default { src, width: 275, height: 48, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ACMJFFUgDBZpGQwWZRwOGW8fDhlwOQQNRTkACC43AAgwUFcEtrsh1ygAAAAASUVORK5CYII="};
